<template>
  <div>
    <b-row class="justify-content-center mb-4">
      <b-col cols="12" sm="6">
        <!-- NOTE: Always default on copropriété -->
        <label class="w-100">{{ $t("catalogs.Statut_de_copropriété") }}</label>
        <b-form-checkbox
          :value="1"
          :unchecked-value="0"
          :checked="building.co_ownership"
          class="d-inline"
          switch
          :disabled="!building.asl"
          @change="updateBuilding('co_ownership', $event)"
        />
        <span>
          <font-awesome-icon icon="info-circle" />
          Sélectionnez si l'immeuble est une copropriété. Les mentions légales types de la
          copropriété seront utilisées.
        </span>
      </b-col>
    </b-row>
    <b-row v-if="!isLoading" class="justify-content-center">
      <b-col cols="12" sm="6">
        <label>Indiquer la mention légale</label>
        <ValidationProvider
          ref="vee-building-legal"
          v-slot="{ errors, classes }"
          :name="'mention légale'"
          rules="required"
        >
          <tiptap
            v-model="building.legal"
            :is-editable="!building.co_ownership"
            @updateOnFocusOut="updateBuildingLegal"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <appLoader v-if="isLoading" />
  </div>
</template>

<script>
import ConfigurationMW from "@/middlewares/Configuration";
import ConfigurationORM from "@/store/orm-axios/models/Configuration";
import Tiptap from "@/components/snippets/Tiptap.vue";
export default {
  components: {
    Tiptap,
  },
  props: {
    building: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    legalMentions() {
      var legalMentions = "";

      // There will be only one configuration for each agency id
      var configuration = ConfigurationORM.query().where("agency_id", this.agencyId).first();
      if (configuration && configuration.settings.length > 0) {
        configuration.settings.forEach(element => {
          if (element.legal_mentions) {
            legalMentions = element.legal_mentions;
          }
        });
      }

      return legalMentions;
    },
  },
  created() {
    ConfigurationMW.FETCH(this.agencyId)
      .then(() => {
        this.checkLegalMention();
        this.isLoading = false;
      })
      .catch(err => {
        console.error(err);
        this.isLoading = false;
      });
  },
  methods: {
    updateBuilding(key, value) {
      this.$emit("updateBuilding", key, value);
      this.checkLegalMention();
    },
    checkLegalMention() {
      if (this.building.co_ownership) {
        this.$emit("updateBuilding", "legal", this.legalMentions);
        this.$emit("updateCoOwnership", this.building.co_ownership);
      }
    },
    updateBuildingLegal(legal) {
      this.building.legal = legal;
      this.updateBuilding("legal", legal);
    },
  },
};
</script>
